export enum SAVE_TEMPLATE_PAGE {
    EXISTING_OR_NEW = 'existing_or_new',
    UDPATE = 'update',
    CREATE = 'create',
    SUCCESS = 'success'
}
